
import { Options, Vue } from 'vue-class-component'
import PromotionService from '@/services/PromotionService'
import { ResponseData } from '@/services/types'
import { showError, parseBackendErrors } from '@/composables/utils'
import BaseCheckbox from '@/components/ui/BaseCheckbox.vue'
import BalanceService, { AddAccrualParams } from '@/services/BalanceService'
import LeadValidationBlock from '@/components/core/LeadValidationBlock.vue'

@Options({
  props: {
    mlmId: { type: Number, required: true },
    agentId: { type: Number, required: true },
  },
  emits: ['success', 'error'],
  components: { BaseCheckbox, LeadValidationBlock },
})
export default class AddBalanceForm extends Vue {
  agentId!: number
  mlmId!: number
  amount: number | null = null
  promotionKey = ''
  promotions: Record<string, string> = {}
  rawLeadInput = ''
  holdStatus = false
  errorMessages: string[] = []
  isFormLoading = false
  showValidationBlock = false
  validatedLeadId: number | null = null

  async created() {
    try {
      const response: ResponseData = await PromotionService.getList()
      this.promotions = response.data
    } catch (e: any) {
      showError(e)
    }
  }

  invalidateValidation() {
    this.validatedLeadId = null
    const validator = this.$refs.leadValidator as any
    if (validator?.reset) {
      validator.reset()
    }
  }

  async submit() {
    this.errorMessages = []
    this.isFormLoading = true

    const leadId = this.extractLeadId(this.rawLeadInput)
    if (leadId === null) {
      this.errorMessages = ['Некорректная ссылка или номер лида']
      this.isFormLoading = false
      return
    }

    if (this.validatedLeadId === leadId) {
      await this.onValidationSuccess(leadId)
    } else {
      this.showValidationBlock = true
      await (this.$refs.leadValidator as any).startValidation()
    }

    this.isFormLoading = false
  }

  async onValidationSuccess(leadId: number) {
    this.isFormLoading = true
    try {
      await BalanceService.addAccrual(this.preparePayload(leadId))
      this.validatedLeadId = leadId
      this.showValidationBlock = false
      this.$emit('success')
    } catch (error: any) {
      this.errorMessages = parseBackendErrors(error)
      this.$emit('error', error)
    } finally {
      this.isFormLoading = false
    }
  }

  onValidationError(error: any) {
    this.errorMessages = parseBackendErrors(error)
    this.showValidationBlock = false
    this.isFormLoading = false
    this.validatedLeadId = null
  }

  onLeadValidated(leadId: number) {
    this.validatedLeadId = leadId
  }

  preparePayload(leadId: number): AddAccrualParams {
    return {
      agent_id: this.agentId,
      amount: this.amount,
      promotion: this.promotionKey,
      lead_id: leadId,
      hold_status: this.holdStatus,
    }
  }

  extractLeadId(input: string): number | null {
    const trimmed = input.trim()
    if (/^\d+$/.test(trimmed)) return parseInt(trimmed, 10)

    try {
      const url = new URL(trimmed.startsWith('http') ? trimmed : `https://${trimmed}`)
      const parts = url.pathname.split('/').filter(Boolean)
      const last = parts[parts.length - 1]
      if (last && /^\d+$/.test(last)) return parseInt(last, 10)
    } catch (e) {}

    return null
  }

}
